// Always-visible sun/moon switch. Click flips light↔dark; the dropdown
// also offers "System" so the app can follow the device again.
import React from 'react';
import { Sun, Moon, MonitorSmartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/context/ThemeContext';

export const ThemeToggle = ({ className = '' }) => {
  const { theme, resolved, setTheme, cycle } = useTheme();

  return (
    <div className={`inline-flex items-center ${className}`}>
      <Button
        variant="ghost"
        size="icon"
        onClick={cycle}
        aria-label={resolved === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        title={resolved === 'dark' ? 'Light mode' : 'Dark mode'}
        className="relative h-9 w-9 rounded-full text-foreground/70 hover:text-foreground hover:bg-accent transition-colors"
        data-testid="theme-toggle"
      >
        <Sun className={`h-[18px] w-[18px] transition-all duration-300 ${resolved === 'dark' ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'}`} />
        <Moon className={`absolute h-[18px] w-[18px] transition-all duration-300 ${resolved === 'dark' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'}`} />
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="h-9 px-1 text-[10px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Theme options"
            data-testid="theme-menu-trigger"
          >
            {theme === 'system' ? 'auto' : theme}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          <DropdownMenuItem onClick={() => setTheme('light')} data-testid="theme-set-light">
            <Sun className="h-4 w-4 mr-2" /> Light
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setTheme('dark')} data-testid="theme-set-dark">
            <Moon className="h-4 w-4 mr-2" /> Dark
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setTheme('system')} data-testid="theme-set-system">
            <MonitorSmartphone className="h-4 w-4 mr-2" /> System
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ThemeToggle;
